import { Box } from "rebass";
import styled from "styled-components";
import { maxWidth } from "styled-system";

const HR = ({ maxWidth = 3, color = "yellow" }) => {
  return <S_HR maxWidth={maxWidth} mx="auto" color={color} />;
};

const S_HR = styled(Box)`
  ${maxWidth}
  height: 1px;

  &::after {
    content: "";
    height: 100%;
    background: currentColor;
    display: block;
  }
`;

export { HR };
